/**
 * Created by dvircohen on 21/09/2016.
 */
(function () {
    'use strict';

    // @ngInject
    function EmailTemplateEmptyStateControllerCtor($scope, $injector, AnalyticsService, TemplatesViewService, $state, AppStates) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'EmailTemplateEmptyStateController';
        AnalyticsService.trackPageView(this, 'EmailTemplateEmptyStateView');

        this.TemplatesViewService = TemplatesViewService;
        this.$state = $state;
        this.AppStates = AppStates;
    }

    Controllers.EmailTemplateEmptyStateController = Class(Controllers.BaseController, {
        constructor: EmailTemplateEmptyStateControllerCtor
    });
}());

